import { CartAddEvent } from '@theme/events';

// Kept separate from the native product-form. Ordinary add-to-cart and express
// checkout keep their original behaviour; only this explicit bundle CTA adds Y.
if (!customElements.get('ss8-mask-addon')) {
  class MaskAddon extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.busy = false;
      this.addEventListener('change', () => this.refresh(), { signal });
      this.querySelector('[data-mask-submit]')?.addEventListener('click', () => this.addBundle(), { signal });
      document.addEventListener('variant:update', () => this.refresh(), { signal });
      document.addEventListener('variant:selected', () => this.refresh(), { signal });
      this.refresh();
    }
    disconnectedCallback() { this.abort?.abort(); }
    get form() { return document.getElementById(this.dataset.formId); }
    get selected() { return this.querySelector('input[name^="ss8-mask-size-"]:checked'); }
    refresh() {
      const button = this.querySelector('[data-mask-submit]');
      const native = this.form?.querySelector('[name="add"]');
      button.disabled = this.busy || !this.selected || !this.form || !native || native.disabled;
      button.textContent = this.busy ? this.dataset.adding : (this.selected ? this.dataset.button : this.dataset.choose);
    }
    async addBundle() {
      if (this.busy || !this.selected || !this.form?.reportValidity()) return;
      const form = this.form;
      const native = form.querySelector('[name="add"]');
      if (!native || native.disabled) return;
      const fields = new FormData(form);
      const id = Number(fields.get('id'));
      const quantity = Number(fields.get('quantity') || 1);
      const addon = Number(this.selected.value);
      if (!Number.isSafeInteger(id) || !Number.isSafeInteger(addon) || !Number.isInteger(quantity) || quantity < 1) return;
      if (id === addon) return;
      const status = this.querySelector('[data-mask-status]');
      const original = { id, quantity };
      const properties = {};
      for (const [key, value] of fields.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      if (Object.keys(properties).length) original.properties = properties;
      if (fields.get('selling_plan')) original.selling_plan = Number(fields.get('selling_plan'));
      const root = window.Shopify?.routes?.root || '/';
      this.busy = true;
      status.textContent = '';
      this.refresh();
      native.disabled = true;
      let added = false;
      try {
        // Preview-only test code. The production build uses an automatic
        // discount and never replaces a customer's discount-code selection.
        if (this.dataset.previewCode) {
          const response = await fetch(root + 'cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: this.dataset.previewCode }),
          });
          if (!response.ok) throw new Error(this.dataset.error);
        }
        const sections = [...new Set([...document.querySelectorAll('cart-items-component')]
          .map(el => el.dataset.sectionId).filter(Boolean))].slice(0, 5);
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [original, { id: addon, quantity: 1 }],
            sections, sections_url: window.location.pathname }),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        added = true;
        const cartResponse = await fetch(root + 'cart.js');
        if (!cartResponse.ok) {
          // The add already succeeded: show the cart rather than retrying and
          // risking a duplicate addition after an ambiguous network response.
          window.location.assign(root + 'cart');
          return;
        }
        const cart = await cartResponse.json();
        this.dispatchEvent(new CartAddEvent(cart, String(id), {
          source: 'product-form-component', itemCount: quantity + 1,
          productId: this.dataset.productId, sections: result.sections,
        }));
        status.textContent = this.dataset.success;
      } catch (error) {
        if (added) window.location.assign(root + 'cart');
        else status.textContent = error.message || this.dataset.error;
      } finally {
        this.busy = false;
        // Never override a variant change/sold-out state that occurred mid-add.
        const currentId = Number(new FormData(form).get('id'));
        if (currentId === id) native.disabled = false;
        this.refresh();
      }
    }
  }
  customElements.define('ss8-mask-addon', MaskAddon);
}
